export const pageItem = {
    // ロード完了したとき
    loadDone: function (results, paramList) {
        $(".js-ajax").html(results["template"]);
        $(".js-content").hide().fadeIn(300);

        // 保存ボタンが押されたときの挙動。
        $(".js-submit").unbind();
        $(".js-submit").click(function () {
            form.disableButtons(this);

            //おむつ定額サービスその他以外はテキストを初期化する
            if ($('input[name="optionType[13]"]:checked').val() !== "4") {
                $('input[name="diapersSubscriptionEtcContent"]').val("");
            }
            $(".nursery__side-menu-content").data("editing", "false");
            window.removeEventListener("beforeunload", nursery.saveAlert);
            const url = $("#lifeForm").attr("action");
            form.post(url, "#lifeForm", "更新が完了しました", () => {
                pageItem.postDone();
                form.activateButtons(this);
            });
        });

        // フォームに変更があった際、離脱時にアラートを表示
        $("form").change(function () {
            $(".nursery__side-menu-content").data("editing", "true");
            window.addEventListener("beforeunload", nursery.saveAlert);
        });
    },

    // POST完了
    postDone: function (results) {
        $("#js-nav-pagetop").trigger("click");
    }
};
